<dt class="col-sm-3">{{ title }}</dt>

<dd class="col-sm-9">
  @if (items?.length > 0) {
    @for (item of items; track item; let isLast = $last) {
      {{ property ? item[property] : item }}{{ isLast ? "" : ", " }}
    }
  } @else {
    {{ item }}
  }


  @if (required) {
    <span class="bg-danger p-1 me-2">{{ "forms.common.required" | translate }}</span>
    <a [routerLink]="routerLinkOptions">{{ "forms.educationalResource.preview.addMissingDetail" | translate }}</a>
  }
</dd>
